import { Validators } from '@angular/forms';

export class LiabilitiesDetailsModel {
  liabilitiesList = {
    value: [],
    validation: Validators.compose([])
  };
  totalLiabilitiesValue = {
    value: 0,
    validation: Validators.compose([])
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class IndividualLiabilityModel {

  force = { // if force = true, type will be fixed and unremovable
    value: false,
    validation: Validators.compose([
      Validators.required
    ])
  };

  description = {
    value: null,
    validation: Validators.compose([])
  };

  type = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  amount = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9.]*'),
      Validators.min(0)
    ])
  };

  limitValue = {
    value: 0,
    validation: Validators.compose([
      Validators.pattern('[0-9.]*'),
      Validators.min(0)
    ])
  };

  lender = {
    value: null,
    validation: Validators.compose([])
  };

  refinance = {
    value: false,
    validation: Validators.compose([])
  };

  interestOnly = {
    value: false,
    validation: Validators.compose([])
  };

  postSettlement = {
    value: 0,
    validation: Validators.compose([
      Validators.pattern('[0-9.]*'),
      Validators.min(0)
    ])
  };

  parties = [];
}
